// Handing a blob to the browser as a download.
//
// In `host/` rather than the kernel because it is pure DOM: an anchor, a click, and an object
// URL that has to be revoked or the blob leaks for the life of the document.
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = 'noopener';
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  // The click has already started the download; the URL can go on the next turn.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
